import React from 'react';
import { Link } from 'react-router-dom';
import { Mountain, Mail, Phone, MapPin, Instagram, Linkedin, Facebook } from 'lucide-react';
import { footerData } from '../mockData';

const Footer = () => {
  const iconMap = {
    instagram: Instagram,
    linkedin: Linkedin,
    facebook: Facebook
  };

  return (
    <footer className="bg-stone-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <div className="bg-sage-700 p-2 rounded-lg">
                <Mountain className="h-6 w-6" />
              </div>
              <div>
                <div className="font-bold text-lg">{footerData.companyName}</div>
              </div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              {footerData.tagline}
            </p>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h3 className="font-semibold text-lg mb-4">Contact Us</h3>
            <div className="space-y-3">
              <a href={`mailto:${footerData.email}`} className="flex items-center space-x-3 text-gray-400 hover:text-sage-400 transition-colors group">
                <Mail className="h-5 w-5 group-hover:scale-110 transition-transform" />
                <span className="text-sm">{footerData.email}</span>
              </a>
              <a href={`tel:${footerData.phone}`} className="flex items-center space-x-3 text-gray-400 hover:text-sage-400 transition-colors group">
                <Phone className="h-5 w-5 group-hover:scale-110 transition-transform" />
                <span className="text-sm">{footerData.phone}</span>
              </a>
              <div className="flex items-center space-x-3 text-gray-400">
                <MapPin className="h-5 w-5" />
                <span className="text-sm">{footerData.address}</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="font-semibold text-lg mb-4">Resources</h3>
            <div className="space-y-2">
              {footerData.quickLinks.map((link) => (
                <a
                  key={link.id}
                  href={link.url}
                  className="block text-gray-400 hover:text-sage-400 transition-colors text-sm"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          {/* Social Links */}
          <div className="space-y-4">
            <h3 className="font-semibold text-lg mb-4">Follow Us</h3>
            <div className="flex space-x-4">
              {footerData.socialLinks.map((social) => {
                const Icon = iconMap[social.platform];
                return (
                  <a
                    key={social.id}
                    href={social.url}
                    className="bg-stone-800 p-3 rounded-lg hover:bg-sage-700 transition-colors group"
                    aria-label={social.platform}
                  >
                    <Icon className="h-5 w-5 group-hover:scale-110 transition-transform" />
                  </a>
                );
              })}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-stone-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © {new Date().getFullYear()} {footerData.companyName}. All rights reserved.
            </p>
            <p className="text-gray-400 text-sm">
              Preserving land. Building legacies.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
